import { render, staticRenderFns } from "./FlightResponsePresentation.vue?vue&type=template&id=515ccb30&scoped=true&"
import script from "./FlightResponsePresentation.vue?vue&type=script&lang=js&"
export * from "./FlightResponsePresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ccb30",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VDivider,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515ccb30')) {
      api.createRecord('515ccb30', component.options)
    } else {
      api.reload('515ccb30', component.options)
    }
    module.hot.accept("./FlightResponsePresentation.vue?vue&type=template&id=515ccb30&scoped=true&", function () {
      api.rerender('515ccb30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/OfferPresentation/FlightResponsePresentation.vue"
export default component.exports